import * as yup from "yup";
import { emailReg, } from "../constants/CommonRegex";
export const loginInitialState = {
    email: "",
    password: "",
    recaptcha: "",
};
export const loginValidationSchema = () => {
    return yup.object().shape({
        email: yup.string().trim().required("Required").matches(emailReg, "Enter valid email"),
        password: yup.string().trim().required("Required"),
    });
};
